"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.printHeaderRangeTranslations = {
    "en": {
        accountName: "Account Name:",
        accountId: "Account ID:",
        createdOn: "Created on:",
    },
    "de": {
        accountName: "Konto Name:",
        accountId: "Konto ID:",
        createdOn: "Erstellt am:",
    },
    "nl": {
        accountName: "Account Name:",
        accountId: "Account ID:",
        createdOn: "Created on:",
    },
    "it": {
        accountName: "Account Name:",
        accountId: "Account ID:",
        createdOn: "Created on:",
    },
    "fr": {
        accountName: "Nom Compte:",
        accountId: "ID Compte:",
        createdOn: "Créé le:",
    },
    "es": {
        accountName: "Nombre de la Cuenta:",
        accountId: "Id de la Cuenta:",
        createdOn: "Creada en:",
    },
    "ja": {
        accountName: "アカウント名:",
        accountId: "アカウントID:",
        createdOn: "作成場所:",
    },
    "en-GB": {
        accountName: "Account Name:",
        accountId: "Account ID:",
        createdOn: "Created on:",
    },
    "ru": {
        accountName: "Имя Аккаунта:",
        accountId: "Идентификатор Аккаунта:",
        createdOn: "Создан:",
    },
};
